<template>
  <section>
    <div class="mb-8 shadow-md px-8 py-4">
      <div class="grid grid-cols-12">
        <div class="col-span-12 md:col-span-6">
          <span class="p-input-icon-right w-full">
            <InputText
              type="text"
              v-model="filterByName"
              :placeholder="$t('course.search')"
              class="p-inputtext-sm"
              @keyup.stop="filterCourseByName()"
            />
            <i class="pi pi-search" />
          </span>
        </div>
      </div>
    </div>

    <Loader :loader="loading" loaderSize="h-96" />

    <div id="content" v-if="(courses || courses.length !== 0) && !loading">
      <div class="grid grid-cols-12 gap-3 p-8">
        <div
          v-for="(course, i) in courses"
          :key="i"
          class="col-span-12 sm:col-span-4 lg:col-span-3 xl:col-span-3 hover:cursor-pointer hover:shadow-lg"
        >
          <CardCourseComponent
            :course="course"
            :stats="true"
            @click.prevent="goToCourse(course)"
          />
        </div>
      </div>

      <div
        class="border-t-2 border-gray-100 mt-8 flex justify-end px-8 py-2"
        v-if="params?.total > params?.size"
      >
        <Paginator
          :rows="params?.size"
          :totalRecords="params?.total"
          @page="paginate($event)"
          :rowsPerPageOptions="[params?.size, 20, 30]"
        ></Paginator>
      </div>
    </div>

    <div class="py-20" v-if="(!courses || courses.length === 0) && !loading">
      <EmptyData
        :data="!courses || courses.length == 0"
        :label="emptyState.description"
        :image="emptyState.image"
        imgSize="h-40 md:h-64"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { Course, CourseType, Status } from "@/models/courses.model";
import { QueryParams } from "@/models/query-params.model";
import { CoursesGenerics } from "@/utils/courses.util";
import { GoToRoute } from "@/utils/go-to.util";
import { ModalUtils } from "@/utils/modals.utils";
import { getUserFromStorage } from "@/utils/user-store.util";
import { debounceTime, map } from "rxjs";
import { defineComponent } from "vue";
import { StatsService } from "./../stats.service";

export default defineComponent({
  name: "dashboardTeacher",
  computed: {
    service(): StatsService {
      return new StatsService();
    },
    courseGenerics(): CoursesGenerics {
      return new CoursesGenerics();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      courses: [] as any,
      active: 0 as number,
      filterByName: "" as string,
      emptyState: {
        image: "empty_courses.svg",
        description: this.$t("course.empty.courses"),
      } as any,
      params: new QueryParams(0, 12) as any,
      tabs: [] as any,
      dialogText: {} as ModalUtils,
      reason: "" as string,
      course: {} as Course,
      dialogModals: false as boolean,
      loading: true as boolean,
      status: Status.PUBLISHED.concat(",").concat(Status.NOT_LISTED) as string,
    };
  },
  mounted() {
    this.coursesPaginated();
  },
  methods: {
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      params.status = this.status;
      this.filterByName = "";
      this.setPage(params);
    },
    setPage(queryParams: QueryParams): void {
      this.service.courses.pipe(debounceTime(500)).subscribe({
        next: (response: any) => {
          if (response.content) {
            response.content.map((res) => {
              res.percentage = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
              res.average = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
              res.enrolled = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
            });
            this.courses = response.content.filter(
              (e) => e.type !== CourseType.INTERACTIVE
            );
            this.params.total = response.total;
            this.loading = false;
          }
        },
        error: () => {
          this.loading = false;
        },
      });
      this.service.getCourses(queryParams);
    },
    coursesPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      this.params = new QueryParams(page, size);
      this.params.status = this.status;
      this.setPage(this.params);
    },
    filterCourseByName(): void {
      this.params.name = this.filterByName;
      this.setPage(this.params);
    },
    goToCourse(course: Course): void {
      this.go.redirectToPage("statsCourse", {
        courseId: course?.id,
        courseName: course?.name,
      });
      localStorage.setItem(
        "isAdaptiveStats",
        JSON.stringify(course?.type === CourseType.ADAPTATIVE)
      );
    },
  },
});
</script>
